module.exports = "/assets/cb422c5881fbf919e21710eac6cc011e.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/9D.png
// module id = 1156
// module chunks = 0